"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Dropdown = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _ = require("..");
var _Option = _interopRequireDefault(require("./Option"));
var _context = require("../Form/context");
var _Button = _interopRequireDefault(require("../Button"));
var _excluded = ["value", "label", "filter", "disabled", "showError", "className", "curved", "iconRight", "title", "onAdd", "required", "truncateSelected"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* babel-plugin-inline-import './icon-cross.svg' */
var CrossIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iOCIgaGVpZ2h0PSI4Ij48ZGVmcz48cGF0aCBkPSJNMTQuODYyIDguMTk1YS42NjcuNjY3IDAgMDEuOTQzLjk0M0wxMi45NDMgMTJsMi44NjIgMi44NjJjLjIzNC4yMzQuMjU3LjYuMDcuODZsLS4wNy4wODNhLjY2Ny42NjcgMCAwMS0uOTQzIDBMMTIgMTIuOTQzbC0yLjg2MiAyLjg2MmEuNjY3LjY2NyAwIDAxLS44Ni4wN2wtLjA4My0uMDdhLjY2Ny42NjcgMCAwMTAtLjk0M0wxMS4wNTcgMTIgOC4xOTUgOS4xMzhhLjY2Ny42NjcgMCAwMS0uMDctLjg2bC4wNy0uMDgzYy4yNi0uMjYuNjgzLS4yNi45NDMgMEwxMiAxMS4wNTd6IiBpZD0iYSIvPjwvZGVmcz48dXNlIGZpbGw9IiM1NTYyNzIiIGZpbGwtcnVsZT0ibm9uemVybyIgeGxpbms6aHJlZj0iI2EiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04IC04KSIvPjwvc3ZnPg==";
/* babel-plugin-inline-import './icon-dropdown.svg' */
var DropdownIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPjxkZWZzPjxwYXRoIGQ9Ik04LjMyMyAxMy42NjhsMy42ODYgMy42ODYgMy43MDItMy41NzNhLjc3Ljc3IDAgMDExLjA5My4wMjYuNzcuNzcgMCAwMS0uMDEyIDEuMDkyTDEyLjU0NyAxOWEuNzY4Ljc2OCAwIDAxLS45NjUuMDguODU1Ljg1NSAwIDAxLS4xODYtLjEzOWwtNC4xNzItNC4xNzJhLjc3Ljc3IDAgMDEuMDA3LTEuMDkzLjc3Ljc3IDAgMDExLjA5Mi0uMDA3em00LjEzNi05LjUyNmwuMDg4LjA3MiA0LjI0NSA0LjFhLjc3Ljc3IDAgMDEuMDEyIDEuMDkyLjc3Mi43NzIgMCAwMS0xLjAwNS4wOTlsLS4wODgtLjA3My0zLjcwMS0zLjU3NS0zLjY4NyAzLjY4OGEuNzY3Ljc2NyAwIDAxLTEuMDA1LjA2OGwtLjA4Ny0uMDc1YS43Ny43NyAwIDAxLS4wMDctMS4wOTNsNC4xNzItNC4xNzJhLjc2OC43NjggMCAwMS4xODUtLjEzN2wtLjA0LjAyN2EuNzcuNzcgMCAwMS45MTgtLjAyMXoiIGlkPSJhIi8+PC9kZWZzPjx1c2UgZmlsbD0iIzY5Njk2ZSIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPjwvc3ZnPg==";
/* babel-plugin-inline-import './icon-search.svg' */
var SearchIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjIiIGhlaWdodD0iMjIiPjxkZWZzPjxwYXRoIGQ9Ik05LjY1NiAxYzQuNzcyIDAgOC42NTYgMy44ODMgOC42NTYgOC42NTZhOC42MDQgOC42MDQgMCAwMS0xLjUyIDQuODg2bDUuNzQzIDUuNzQyQTEuNTkyIDEuNTkyIDAgMDEyMS40MSAyM2ExLjU4IDEuNTggMCAwMS0xLjEyNC0uNDY2bC01Ljc0Mi01Ljc0MmE4LjYwNCA4LjYwNCAwIDAxLTQuODg4IDEuNTE5QzQuODgzIDE4LjMxMSAxIDE0LjQyOCAxIDkuNjU2IDEgNC44ODMgNC44ODMgMSA5LjY1NiAxek05LjYgM0M1Ljk2IDMgMyA1Ljk2IDMgOS41OThhNi42MDYgNi42MDYgMCAwMDYuNiA2LjU5OCA2LjYwNiA2LjYwNiAwIDAwNi41OTctNi41OThBNi42MDUgNi42MDUgMCAwMDkuNiAzeiIgaWQ9ImEiLz48L2RlZnM+PHVzZSBmaWxsPSIjOTU5REE3IiBmaWxsLXJ1bGU9Im5vbnplcm8iIHhsaW5rOmhyZWY9IiNhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMSAtMSkiLz48L3N2Zz4=";
var MAX_HEIGHT = 200;
var Dropdown = /*#__PURE__*/function (_PureComponent) {
  _inherits(Dropdown, _PureComponent);
  var _super = _createSuper(Dropdown);
  function Dropdown() {
    var _this;
    _classCallCheck(this, Dropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false,
      filterString: '',
      error: '',
      touched: false,
      focus: 0
    });
    _defineProperty(_assertThisInitialized(_this), "dropdown", null);
    _defineProperty(_assertThisInitialized(_this), "options", null);
    _defineProperty(_assertThisInitialized(_this), "input", null);
    _defineProperty(_assertThisInitialized(_this), "initialHeight", 0);
    _defineProperty(_assertThisInitialized(_this), "dropdownIcon", null);
    _defineProperty(_assertThisInitialized(_this), "tags", null);
    _defineProperty(_assertThisInitialized(_this), "getRef", function () {
      return _this.dropdown;
    });
    _defineProperty(_assertThisInitialized(_this), "onOptionClick", function (clickedOption) {
      var _this$props$onClose, _this$props;
      _this.setState({
        open: false
      });
      (_this$props$onClose = (_this$props = _this.props).onClose) === null || _this$props$onClose === void 0 ? void 0 : _this$props$onClose.call(_this$props);
      _this.props.onChange(clickedOption);
    });
    _defineProperty(_assertThisInitialized(_this), "checkOutsideClick", function (e) {
      var _this$options;
      if (_this.state.open && !((_this$options = _this.options) !== null && _this$options !== void 0 && _this$options.contains(e.target))) {
        var _this$input, _this$input$input, _this$input$input$cur, _this$dropdownIcon, _this$props$onClose2, _this$props2;
        if ((_this$input = _this.input) !== null && _this$input !== void 0 && (_this$input$input = _this$input.input) !== null && _this$input$input !== void 0 && (_this$input$input$cur = _this$input$input.current) !== null && _this$input$input$cur !== void 0 && _this$input$input$cur.contains(e.target) || (_this$dropdownIcon = _this.dropdownIcon) !== null && _this$dropdownIcon !== void 0 && _this$dropdownIcon.contains(e.target)) return;
        _this.setState({
          open: false
        }, _this.onBlur);
        (_this$props$onClose2 = (_this$props2 = _this.props).onClose) === null || _this$props$onClose2 === void 0 ? void 0 : _this$props$onClose2.call(_this$props2);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "isValid", function () {
      var _this$props3 = _this.props,
        value = _this$props3.value,
        required = _this$props3.required;
      if (!required) return true;else _this.setState(_objectSpread(_objectSpread({}, _this.state), {}, {
        error: 'This field is required'
      }));
      if (_this.state.open) return true;
      if (Array.isArray(value)) {
        return !!value.length;
      }
      return !!value;
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
      _this.setState({
        touched: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      var _this$dropdown;
      (_this$dropdown = _this.dropdown) === null || _this$dropdown === void 0 ? void 0 : _this$dropdown.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      var _this$props$onClear, _this$props4;
      (_this$props$onClear = (_this$props4 = _this.props).onClear) === null || _this$props$onClear === void 0 ? void 0 : _this$props$onClear.call(_this$props4);
    });
    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var _this$tags, _this$dropdownIcon2, _this$props$onClose3, _this$props5, _this$props$onOpen, _this$props6;
      e.stopPropagation();
      if (_this.tags !== e.target && (_this$tags = _this.tags) !== null && _this$tags !== void 0 && _this$tags.contains(e.target)) return;
      if (_this.props.disabled || _this.state.open && _this.props.filter && !((_this$dropdownIcon2 = _this.dropdownIcon) !== null && _this$dropdownIcon2 !== void 0 && _this$dropdownIcon2.contains(e.target))) return;
      _this.state.open ? (_this$props$onClose3 = (_this$props5 = _this.props).onClose) === null || _this$props$onClose3 === void 0 ? void 0 : _this$props$onClose3.call(_this$props5) : (_this$props$onOpen = (_this$props6 = _this.props).onOpen) === null || _this$props$onOpen === void 0 ? void 0 : _this$props$onOpen.call(_this$props6);
      _this.setState({
        open: !_this.state.open,
        error: '',
        filterString: !_this.state.open ? '' : _this.state.filterString
      }, function () {
        var _this$input2;
        return (_this$input2 = _this.input) === null || _this$input2 === void 0 ? void 0 : _this$input2.focus();
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      var _this$props$onClose4, _this$props7, _this$props$onClear2, _this$props8;
      _this.setState({
        filterString: '',
        open: false
      });
      (_this$props$onClose4 = (_this$props7 = _this.props).onClose) === null || _this$props$onClose4 === void 0 ? void 0 : _this$props$onClose4.call(_this$props7);
      (_this$props$onClear2 = (_this$props8 = _this.props).onClear) === null || _this$props$onClear2 === void 0 ? void 0 : _this$props$onClear2.call(_this$props8);
    });
    _defineProperty(_assertThisInitialized(_this), "renderValue", function () {
      var _this$props9 = _this.props,
        value = _this$props9.value,
        placeholder = _this$props9.placeholder;
      if (Array.isArray(value)) {
        return value.length ? /*#__PURE__*/_react.default.createElement("div", {
          ref: function ref(r) {
            return _this.tags = r;
          },
          className: "sa-dropdown-tags"
        }, value.map(function (opt, i) {
          return /*#__PURE__*/_react.default.createElement(_.Tag, {
            key: i,
            title: opt.label,
            square: true,
            small: true,
            type: "grey"
          }, opt.label, /*#__PURE__*/_react.default.createElement(_Button.default, {
            title: "".concat(opt.label, " clear button"),
            "aria-label": "".concat(opt.label, ". clear"),
            type: "button",
            tabIndex: _this.state.open ? -1 : 0,
            className: "clear-button",
            elastic: true,
            onClick: function onClick() {
              var _this$props$onDeleteT, _this$props10;
              return (_this$props$onDeleteT = (_this$props10 = _this.props).onDeleteTag) === null || _this$props$onDeleteT === void 0 ? void 0 : _this$props$onDeleteT.call(_this$props10, opt, i);
            },
            onKeyDown: function onKeyDown(evt) {
              if (evt.key === 'Enter' || evt.key === ' ') {
                var _this$props$onDeleteT2, _this$props11;
                evt.preventDefault();
                (_this$props$onDeleteT2 = (_this$props11 = _this.props).onDeleteTag) === null || _this$props$onDeleteT2 === void 0 ? void 0 : _this$props$onDeleteT2.call(_this$props11, opt, i);
              }
            }
          }, /*#__PURE__*/_react.default.createElement("img", {
            src: CrossIcon,
            alt: "Clear"
          })));
        })) : /*#__PURE__*/_react.default.createElement("span", {
          className: 'sa-dropdown-placeholder'
        }, placeholder !== null && placeholder !== void 0 ? placeholder : '');
      }
      return /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)({
          'sa-dropdown-placeholder': !value,
          'sa-selected': !!value
        }),
        "data-testid": "dropdown-value"
      }, _this.state.open ? '' : value || placeholder || '');
    });
    _defineProperty(_assertThisInitialized(_this), "renderOptions", function () {
      var _this$props$_this$sta = _objectSpread(_objectSpread({}, _this.props), _this.state),
        options = _this$props$_this$sta.options,
        value = _this$props$_this$sta.value,
        maxFilterOptions = _this$props$_this$sta.maxFilterOptions,
        expandOptions = _this$props$_this$sta.expandOptions,
        filterString = _this$props$_this$sta.filterString,
        onAdd = _this$props$_this$sta.onAdd,
        onSort = _this$props$_this$sta.onSort,
        minWordLength = _this$props$_this$sta.minWordLength;
      var rendered = options.filter(function recursiveFilter(option) {
        var _option$children;
        if (option.label.toLowerCase().includes(filterString.toLowerCase().trim())) return true;
        if ((_option$children = option.children) !== null && _option$children !== void 0 && _option$children.length) {
          return !!option.children.filter(recursiveFilter).length;
        }
        return false;
      }) // ^^ artwork by liam g :)
      .filter(function (option) {
        return Array.isArray(value) ? !value.map(function (v) {
          return v.label;
        }).includes(option.label) : option;
      }).slice(0, maxFilterOptions).sort(function (a, b) {
        return onSort ? onSort(a, b) : 0;
      }).map(function (option, i) {
        return /*#__PURE__*/_react.default.createElement(_Option.default, {
          renderOptionLabel: _this.props.renderOptionLabel,
          expandOptions: !!expandOptions,
          selectParents: !!_this.props.selectParents,
          value: value,
          key: i,
          onOptionClick: _this.onOptionClick,
          onOptionRemove: _this.props.onRemove,
          option: option
        });
      });
      if (filterString && filterString.length >= (minWordLength || 0) && onAdd) rendered.unshift( /*#__PURE__*/_react.default.createElement(_Option.default, {
        renderOptionLabel: _this.props.renderOptionLabel,
        expandOptions: !!expandOptions,
        selectParents: !!_this.props.selectParents,
        value: filterString,
        key: 'add',
        onOptionClick: function onOptionClick(e) {
          onAdd(e);
          _this.setState({
            filterString: ''
          });
        },
        onOptionAdd: function onOptionAdd(e) {
          onAdd(e);
          _this.setState({
            filterString: ''
          });
        },
        option: {
          label: "Add '".concat(filterString, "'"),
          data: filterString
        }
      }));
      return rendered.length ? rendered : /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-dropdown-options-option no-results"
      }, "No results");
    });
    _defineProperty(_assertThisInitialized(_this), "setDropdown", function (r) {
      _this.dropdown = r;
    });
    _defineProperty(_assertThisInitialized(_this), "onFocusChange", function () {
      var _this$options2;
      var child = (_this$options2 = _this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.children[_this.state.focus];
      var optionButton = child === null || child === void 0 ? void 0 : child.querySelector('.option-button');
      optionButton === null || optionButton === void 0 ? void 0 : optionButton.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeypressOnClear", function (evt) {
      if (evt.key === 'Enter' || evt.key === ' ') {
        _this.onClear();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeypress", function (evt) {
      var focus = _this.state.focus;
      var KEY_CODES = {
        UP: 38,
        DOWN: 40
      };
      if (evt.key === 'Enter' || evt.key === ' ') {
        if (_this.props.preventDefaultInputOnEnterKey) evt.preventDefault();
        _this.onClick(evt);
      }
      if (evt.key === 'Escape') {
        var _this$props$onClose5, _this$props12;
        _this.setState({
          open: false,
          error: '',
          filterString: ''
        });
        (_this$props$onClose5 = (_this$props12 = _this.props).onClose) === null || _this$props$onClose5 === void 0 ? void 0 : _this$props$onClose5.call(_this$props12);
      }
      if (evt.keyCode === KEY_CODES.UP) {
        if (focus === 0) return;
        evt.preventDefault();
        _this.setState({
          focus: focus - 1
        }, _this.onFocusChange);
      }
      if (evt.keyCode === KEY_CODES.DOWN) {
        var _this$options3, _this$options3$childr;
        if (focus === ((_this$options3 = _this.options) === null || _this$options3 === void 0 ? void 0 : (_this$options3$childr = _this$options3.children) === null || _this$options3$childr === void 0 ? void 0 : _this$options3$childr.length) - 1) return;
        evt.preventDefault();
        _this.setState({
          focus: focus + 1
        }, _this.onFocusChange);
      }
    });
    return _this;
  }
  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('mouseup', this.checkOutsideClick, false);
      if (this.props.autoFocus) {
        this.focus();
      }
      if (this.props.attachToForm) {
        this.props.attachToForm(this);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mouseup', this.checkOutsideClick, false);
      if (this.props.removeFromForm) {
        this.props.removeFromForm(this);
      }
    }
  }, {
    key: "getOptionsStyle",
    value: function getOptionsStyle() {
      var _this$dropdown2;
      var rect = (_this$dropdown2 = this.dropdown) === null || _this$dropdown2 === void 0 ? void 0 : _this$dropdown2.getBoundingClientRect();
      if (this.isDropdownFromBottom()) {
        return {
          bottom: rect === null || rect === void 0 ? void 0 : rect.height,
          width: rect === null || rect === void 0 ? void 0 : rect.width,
          position: 'absolute',
          left: -2
        };
      }
      return {
        top: rect === null || rect === void 0 ? void 0 : rect.height,
        left: -2,
        width: rect === null || rect === void 0 ? void 0 : rect.width,
        position: 'absolute'
      };
    }
  }, {
    key: "isDropdownFromBottom",
    value: function isDropdownFromBottom() {
      var y = this.dropdown.getBoundingClientRect().y;
      var body = document.getElementsByTagName('body')[0];
      if (body.scrollHeight <= MAX_HEIGHT) return false;
      return body.scrollHeight - y < MAX_HEIGHT;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        open = _this$state.open,
        filterString = _this$state.filterString,
        error = _this$state.error,
        touched = _this$state.touched;
      var _this$props13 = this.props,
        value = _this$props13.value,
        label = _this$props13.label,
        filter = _this$props13.filter,
        disabled = _this$props13.disabled,
        showError = _this$props13.showError,
        className = _this$props13.className,
        curved = _this$props13.curved,
        iconRight = _this$props13.iconRight,
        title = _this$props13.title,
        onAdd = _this$props13.onAdd,
        required = _this$props13.required,
        truncateSelected = _this$props13.truncateSelected,
        actions = _objectWithoutProperties(_this$props13, _excluded);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_defineProperty({
          'sa-dropdown-wrapper': true
        }, className, !!className))
      }, label && /*#__PURE__*/_react.default.createElement("label", null, label, required ? /*#__PURE__*/_react.default.createElement("span", {
        "aria-hidden": "true"
      }, "*") : null), required && /*#__PURE__*/_react.default.createElement("span", {
        className: "sa-dropdown-label-hidden"
      }, "required"), /*#__PURE__*/_react.default.createElement("div", {
        "aria-label": "".concat(title || label || '', " dropdown"),
        "aria-expanded": open,
        "aria-haspopup": "true",
        title: title || label || 'Dropdown',
        tabIndex: 0,
        role: "button",
        ref: this.setDropdown,
        onBlur: this.onBlur,
        onClick: this.onClick,
        onKeyDown: this.onKeypress,
        className: (0, _classnames.default)({
          'sa-dropdown': true,
          'contains-tags': Array.isArray(value) && value.length,
          error: touched && !this.isValid(),
          curved: curved,
          disabled: disabled,
          open: open,
          'show-ellipsis': truncateSelected
        })
      }, open && filter ? /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-dropdown-filter"
      }, /*#__PURE__*/_react.default.createElement(_.Input, {
        ref: function ref(r) {
          return _this2.input = r;
        },
        placeholder: this.props.placeholder,
        value: filterString,
        preventDefaultOnEnterKey: this.props.preventDefaultInputOnEnterKey,
        onChange: function onChange(filterString) {
          return _this2.setState({
            filterString: filterString
          });
        },
        onSubmit: function onSubmit(filterString) {
          if (onAdd) {
            onAdd({
              label: filterString,
              data: filterString
            });
            _this2.setState({
              filterString: ''
            });
          }
        }
      }), /*#__PURE__*/_react.default.createElement("img", {
        className: "sa-dropdown-filter-icon",
        src: SearchIcon,
        height: 16,
        width: 16,
        alt: "Search"
      })) : null, this.renderValue(), /*#__PURE__*/_react.default.createElement("div", {
        className: "sa-dropdown-icons"
      }, actions.onClear && value !== null && value !== void 0 && value.length ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        className: "full-width",
        onKeyDown: this.handleKeypressOnClear,
        onClick: this.onClear
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "sa-dropdown-icons-cross",
        src: CrossIcon,
        alt: "Clear",
        title: "Clear"
      })) : null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        "aria-hidden": "true",
        type: "button",
        tabIndex: iconRight ? 0 : -1,
        onKeyDown: this.onKeypress,
        onClick: this.onClick
      }, iconRight !== null && iconRight !== void 0 ? iconRight : /*#__PURE__*/_react.default.createElement("img", {
        src: DropdownIcon,
        ref: function ref(r) {
          return _this2.dropdownIcon = r;
        },
        alt: "Dropdown icon",
        title: "Dropdown icon"
      }))), open && /*#__PURE__*/_react.default.createElement("div", {
        role: "listbox",
        ref: function ref(r) {
          return _this2.options = r;
        }
        // accounting for borders
        ,
        style: this.getOptionsStyle(),
        className: (0, _classnames.default)({
          'sa-dropdown-options': true,
          'from-bottom': this.isDropdownFromBottom()
        })
      }, this.renderOptions())), showError && touched && !this.isValid() && /*#__PURE__*/_react.default.createElement("div", {
        className: "input-error"
      }, error));
    }
  }]);
  return Dropdown;
}(_react.PureComponent);
exports.Dropdown = Dropdown;
var forwardRef = /*#__PURE__*/_react.default.forwardRef(function forwardRef(props, ref) {
  return /*#__PURE__*/_react.default.createElement(_context.FormConsumer, null, function (context) {
    return /*#__PURE__*/_react.default.createElement(Dropdown, _extends({}, props, {
      ref: ref,
      attachToForm: context === null || context === void 0 ? void 0 : context.attachToForm,
      removeFromForm: context === null || context === void 0 ? void 0 : context.removeFromForm
    }));
  });
});
var _default = forwardRef;
exports.default = _default;